import { Language } from "../LangSelector/types";
import { FooterLinkType } from "./types";
import {
  TwitterIcon,
  TelegramIcon,
  RedditIcon,
  InstagramIcon,
  GithubIcon,
  DiscordIcon,
  MediumIcon,
  YoutubeIcon,
  Google,
  Facebook,
Linkedin
  
} from "../Svg";

export const footerLinks: FooterLinkType[] = [
  {
    label: "About",
    items: [
      {
        label: "Contact",
        href: "/",
      },
      {
        label: "Blog",
        href: "/",
      },
      {
        label: "Community",
        href: "/",
      },
      {
        label: "CAKE",
        href: "/",
      },
      {
        label: "—",
      },
      {
        label: "Online Store",
        href: "/",
        isHighlighted: true,
      },
    ],
  },
  {
    label: "Help",
    items: [
      {
        label: "Customer",
        href: "Support /",
      },
      {
        label: "Troubleshooting",
        href: "/",
      },
      {
        label: "Guides",
        href: "/",
      },
    ],
  },
  {
    label: "Developers",
    items: [
      {
        label: "Github",
        href: "/",
      },
      {
        label: "Documentation",
        href: "#",
      },
      {
        label: "Bug Bounty",
        href: "#",
      },
      {
        label: "Audits",
        href: "#",
      },
      {
        label: "Careers",
        href: "#",
      },
    ],
  },
];

export const socials = [
  {
    label: "Twitter",
    icon: TwitterIcon,
    href: "https://twitter.com/ART_MRJERUSALEM",
  },
  {
    label: "Facebook",
    icon: Facebook,
    href: "https://www.facebook.com/",
    items: [
      {
        label: "English",
        href: "https://www.facebook.com/",
      },
      // {
      //   label: "Bahasa Indonesia",
      //   href: "#",
      // },
      // {
      //   label: "中文",
      //   href: "#",
      // },
      // {
      //   label: "Tiếng Việt",
      //   href: "#",
      // },
      // {
      //   label: "Italiano",
      //   href: "#",
      // },
      // {
      //   label: "русский",
      //   href: "#",
      // },
      // {
      //   label: "Türkiye",
      //   href: "#",
      // },
      // {
      //   label: "Português",
      //   href: "#",
      // },
      // {
      //   label: "Español",
      //   href: "#",
      // },
      // {
      //   label: "日本語",
      //   href: "#",
      // },
      // {
      //   label: "Français",
      //   href: "#",
      // },
      // {
      //   label: "Deutsch",
      //   href: "#",
      // },
      // {
      //   label: "Filipino",
      //   href: "#",
      // },
      // {
      //   label: "ქართული ენა",
      //   href: "#",
      // },
      // {
      //   label: "हिन्दी",
      //   href: "#",
      // },
      // {
      //   label: "Announcements",
      //   href: "#",
      // },
    ],
  },
  {
    label: "Google",
    icon: Google,
    href: "https://art4coin.io/",
  },
  // {
  //   label: "Facebook",
  //   icon: Facebook,
  //   href: "https://www.facebook.com/",
  // },
  {
    label: "LinkedIn",
    icon: Linkedin,
    href: "https://www.linkedin.com/authwall?trk=gf&trkInfo=AQGqSGq72DCPSwAAAYzqE8tYk08mPWwMqo-GLzQE8Tsch9TarTCQm70pdwFYH-gP_34tNkVckCYFl26wsCfphuA4gx-waEIwkcEy1mwvPS8xuK-CRCapHRqgIyzJGFh6vQGIbL0=&original_referer=https://art4coin.io/&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Fmr-jerusalem-07b278160%2F",
  },
  {
    label: "Instagram",
    icon: InstagramIcon,
    href: "https://www.instagram.com/mr.jerusalem_/",
  },
  // {
  //   label: "Github",
  //   icon: GithubIcon,
  //   href: "#",
  // },
  // {
  //   label: "Discord",
  //   icon: DiscordIcon,
  //   href: "#",
  // },
  // {
  //   label: "Medium",
  //   icon: MediumIcon,
  //   href: "#",
  // },
  {
    label: "Youtube",
    icon: YoutubeIcon,
    href: "https://www.youtube.com/",
  },
];

export const langs: Language[] = [...Array(20)].map((_, i) => ({
  code: `en${i}`,
  language: `English${i}`,
  locale: `Locale${i}`,
}));
